module.exports = __webpack_public_path__ + "img/partner_30.6afd0221.png";